import isEqual from 'lodash/isEqual';
import sortBy from 'lodash/sortBy';
import { config } from '../../vue/config/buyout';

export { URLS } from './urls';
export { apiAxios } from './axios';
export { displayError } from './_errors';
export { buildImageUrl } from './_image';

export const sleep = ms => {
	return new Promise(resolve => setTimeout(resolve, ms));
}

export const sortByOrder = arr => sortBy(arr, 'order');

export const changeRouteParam = async (paramsToChange, routeName = 'home') => {
	const params = { ...config.router.currentRoute.params, ...paramsToChange }

	if (isEqual(config.router.currentRoute.params, params)) {
		return;
	}

	try {
		await config.router.replace({
			name: routeName,
			params: Object.assign(config.router.currentRoute.params, paramsToChange)
		});
	} catch (e) {
		console.warn(e);
	}
}

export const slugify = string => {
	return string
		.toString()
		.trim()
		.toLowerCase()
		.replace('?', '')
		.replace(/\s+/g, '-')
		.replace(/[^\w-]+/g, '')
		.replace(/-+/g, '-')
		.replace(/^-+/, '')
		.replace(/-+$/, '');
}
